import Footer from "../../components/common/layout/Footer";
import { Breadcrumbs, IntroSection, OtherServices, WhyChooseUs } from "@/components/features/aiSolutions";
import SEO from "@/components/common/seo/seo";
import CallToAction from "@/components/common/sections/CallToAction";

export default function AiSolutions() {
    return (
        <div>
            <SEO
                title="AI Solutions - SAN micron"
                description="Empowering businesses through seamless technology and exceptional service, one conversation at a time."
            />
            <Breadcrumbs />
            <IntroSection />
            <WhyChooseUs />
            <CallToAction
                title="Our solutions are Scalable Infrastructure"
            />
            <OtherServices />
            <Footer />
        </div>
    );
}